<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><i>PART II</i></p>
<p class="part-h1">OUT OF THE WILDERNESS 1837–1865</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?5de2dfa2